const state = {
  accessories: [],
  accessoriesInfoList: [],
  accessoriesToDestroy: [],
};

if (Spree.accessories_info) {
  state.accessoriesInfoList = Spree.accessories_info.map((accessory, idx) => ({
    ...accessory,
    quantity: '1',
    selected: false,
    index: idx,
    selected_variant: _.cloneDeep(accessory.variants.length > 0 ? accessory.variants[0] : accessory.master),
  }));
}

export default state;
